module.exports = __webpack_public_path__ + "static/media/esLogo.ba6d3417.png";